import { CognitoUserPool } from "amazon-cognito-identity-js"

const poolData = {
    UserPoolId: process.env.REACT_APP_USERPOOL_ID!, //Needed '!' in order to pass "type 'string | undefined' is not assignable to type 'string'." error
    ClientId: process.env.REACT_APP_APPCLIENT_ID!,
}

export default new CognitoUserPool(poolData);